"use strict";
import _ from "underscore";
import Api from "../api/api";
import documentTypes from "./documents/types";
export default {
  validMappedType: function(document) {
    let type;
    if (document && (type = document.type || document.document_type)) {
      return this._typesMap()[type];
    }
  },
  title: function(document) {
    if (document.type_name) {
      return document.type_name;
    }
    const mapped = this.validMappedType(document);
    return mapped ? mapped.name : "Unidentified";
  },
  titleForType: function(type, defaultTitle = "Unidentified") {
    const mapped = this._typesMap()[type];
    return mapped ? mapped.name : defaultTitle;
  },
  types: function() {
    return documentTypes.types(Auth._currentUser);
  },
  activeTypes: function() {
    if (Api.Account.useDocumentTypeHotkeys()) {
      var enabledTypes = this.enabledTypes();
      var documentTypeHotkeysOrdering = Api.Account.currentSettings().document_type_hotkeys_ordering;
      if (!documentTypeHotkeysOrdering || documentTypeHotkeysOrdering.length === 0) {
        return enabledTypes;
      }
      var mappedOrdering = documentTypeHotkeysOrdering.map(
        (typeValue) => enabledTypes.find((doctype) => doctype.value === typeValue)
      ).filter((docType) => !!docType);
      var remainingEnabledTypes = enabledTypes.filter(
        (doctype) => !documentTypeHotkeysOrdering.includes(doctype.value)
      );
      return mappedOrdering.concat(remainingEnabledTypes);
    }
    return this.enabledTypes();
  },
  enabledTypes: function() {
    if (Api.Account.current().enabled_document_type_names) {
      return _.sortBy(Api.Account.current().enabled_document_type_names, _.property("name"));
    }
    var enabled = Api.Account.currentSettings().enabled_document_types;
    var enabledTypes = _.select(this.types(), function(type) {
      return enabled.indexOf(type.value) >= 0;
    });
    return _.sortBy(enabledTypes, _.property("name"));
  },
  _typesMap: _.memoize(function() {
    var typesMap = {};
    _.each(this.types(), function(type) {
      typesMap[type.value] = type;
    });
    typesMap["factoringAssignment"] = typesMap["noticeOfAssignment"];
    typesMap["loadTender"] = typesMap["rateConfirmation"];
    return typesMap;
  })
};
